<template>
  <div class="py-1">
    <v-expansion-panels accordion v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header style="font-size: 1.25rem; font-weight: 500; letter-spacing: 0.0125em">
          {{ title }} [{{ items.length }}]
          <v-spacer />
          <div v-if="panel !== undefined && false" class="text-right pa-0">
            <v-btn class="ma-0" @click.native.stop="addItem()" color="primary">Добавить</v-btn>
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card-text :style="`height: ${detailHeight}px; overflow: auto`" class="pa-0">
            <a-table-f-data2
              ref="tableSchedule"
              :dataTable="items"
              :useQuery="false"
              :model="model"
              :searchable="false"
              :defaults="{
                filters: {},
                sort: {},
                paramName: 'work',
              }"
              @click="onClickRow($event)"
            >
              <template v-slot:item.actions="{ row }">
                <div class="d-flex" v-if="(data.status === 1 || row) && accessEdit">
                  <v-btn x-small fab class="ma-0" color="red" title="Удалить" @click.stop="remove(row.id)">
                    <v-icon small>fas fa-times</v-icon>
                  </v-btn>
                </div>
              </template>
            </a-table-f-data2>
          </v-card-text>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <s-document-dialogs-detail-edit
      ref="detail"
      v-if="showEditDialog"
      v-model="showEditDialog"
      :id="idEdit"
      :dataTable="items"
      :readonly="false"
      :RO="fieldsRO"
      :m="m"
      type=""
      @save="items = $event"
      @refresh="fitchData()"
      @commit="onCommit($event)"
      @onChange="onChange($event)"
    >
    </s-document-dialogs-detail-edit>
  </div>
</template>

<script>
import { getAccess, popupMenu, autoHeightBlock } from "@/components/mixings";
export default {
  mixins: [getAccess, popupMenu, autoHeightBlock],
  components: {},
  props: {
    id: Number,
    title: { type: String, default: "Спецификация" },
    data: { type: Array, default: () => [] },
    height: { type: Number, default: 300 },
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      panel: undefined,
      idEdit: 0,
      fieldsRO: [],
      m: {
        list: [
          { name: "actions", width: 40 },
          { name: "department", title: "Отдел", type: "select", sourceList: "department", sortable: true, width: 100 },
          { name: "name", title: "Наименование", type: "string", sortable: !true, width: 220, style: "white-space: normal;" },
          { name: "work_days", title: "Дней", type: "number", sortable: !true, width: 50, style: "text-align: center;" },
          { name: "square", title: "Площадь", type: "number", sortable: !true, width: 60 },
          { name: "price_square", title: "Цена м2", type: "number", sortable: !true, width: 80 },
          { name: "work_cost", title: "Стоимость", type: "number", sortable: !true, width: 100 },
        ],
        form: [
          { name: "department", title: "Отдел", type: "select", sourceList: "department" },
          { name: "service_id", title: "Наименование", type: "selectwork", validator: ["req"] },
          { name: "work_days", title: "Дней", type: "number", size: 2 },
          { name: "date_start", title: "Начало", type: "datestring", validator: ["req1"], size: 5 },
          { name: "date_end", title: "Конец", type: "datestring", validator: ["req1"], size: 5 },
          { name: "square", title: "Площадь", type: "number", validator: ["req"], size: 4 },
          { name: "price_square", title: "Цена м2", type: "number", validator: ["req"], size: 4 },
          { name: "work_cost", title: "Стоимость", type: "number", validator: ["req"], size: 4 },
          { name: "description", title: "Описание", type: "text" },
        ],
      },
      showEditDialog: false,
    };
  },
  created() {},
  watch: {},
  computed: {
    model() {
      return this.m.list;
    },
    accessEdit() {
      return true;
    },
    items: {
      get() {
        let d;
        try {
          d = this.value;
          if (!d) d = [];
        } catch (error) {
          d = [];
        }
        return d;
      },
      set(v) {
        console.log("set items", v);
        this.$emit("input", v);
        //    this.$emit("input", this.isReverse ? v.reverse() : v);
      },
    },
    canAdd() {
      return true;
    },
  },
  methods: {
    onChange(e) {
      if (e.e == "square") {
        const c = e.d.work_cost;
        const s = e.d.square;
        const p = e.d.price_square;
        this.$refs.detail.updateDataField("work_cost", s * p);
      }
      if (e.e == "work_cost") {
        const c = e.d.work_cost;
        const s = e.d.square;
        const p = e.d.price_square;
        this.$refs.detail.updateDataField("price_square", c / (s || 1));
      }
      if (e.e == "price_square") {
        const c = e.d.work_cost;
        const s = e.d.square;
        const p = e.d.price_square;
        this.$refs.detail.updateDataField("work_cost", p * s);
      }
    },
    onCommit(e) {
      if (e.el.name == "service_id") {
        let res = JSON.parse(JSON.stringify(e.event || {}));
        this.data.name = res?.name || null;

        this.$refs.detail.updateDataField("name", res?.name || null);
        this.$refs.detail.updateDataField("work_days", res?.data?.work_days || null);
        return;
        this.data.work_days = res?.data?.work_days || null;
        this.data.work_value = res?.data?.work_value || null;
        this.data.data.category_id = res?.category_id || null;
        this.data.data.description = res?.data?.description || null;
      }
    },
    onClickRow(e) {
      if (e.field.name == "actions") {
      } else {
        this.idEdit = e.row.id || e.key;

        this.showEditDialog = true;
      }
    },
    remove(key) {
      let e = this.items.filter((i) => i.id !== key);
      //      e.splice(key, 1);
      this.items = e;
    },
    addItem() {
      this.idEdit = 0;
      this.showEditDialog = true;
      return;
      let e = this.items;
      e.push({});
      this.items = e;
    },
  },
};
</script>

<style lang="sass">
.v-expansion-panel-content__wrap
  padding: 0 10px 10px
.v-slide-group1__prev--disabled
  display: none !important
.v-slide-group1__next--disabled
  display: none !important
</style>
